module.exports = __webpack_public_path__ + "static/media/profile-default_icon.78d21f54.svg";